"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = void 0;
var React = require("react");
var styled_components_1 = require("styled-components");
var _Core_1 = require("../../_Core");
var keyboard = require("../../_Core/Keyboard");
var Icon_1 = require("../../Icons/Icon/Icon");
var Theme_1 = require("../../Theme");
var WrapperDiv = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: inline-flex;\n    align-items: center;\n    position: relative;\n    vertical-align: middle;\n\n    &[aria-disabled = \"true\"] {\n        opacity: ", ";\n        pointer-events: none;\n    }\n"], ["\n    display: inline-flex;\n    align-items: center;\n    position: relative;\n    vertical-align: middle;\n\n    &[aria-disabled = \"true\"] {\n        opacity: ", ";\n        pointer-events: none;\n    }\n"])), Theme_1.DisabledOpacity);
WrapperDiv.displayName = "WrapperDiv";
var CheckBox = styled_components_1.default.button(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: relative;\n    padding: 0px;\n    color: white;\n    border-radius: 4px;\n    background: #FFFFFF;\n    border: 1px solid #C5C9D1;\n    box-shadow: inset 0 1px 3px 0 rgba(0,0,0,0.07);\n    margin-right: ", ";\n    display: flex;\n    cursor: pointer;\n\n    &:hover {\n        border: 1px solid ", ";\n    };\n\n    &[aria-checked = \"true\"] {\n        ", "\n        border: 0px;\n    }\n"], ["\n    position: relative;\n    padding: 0px;\n    color: white;\n    border-radius: 4px;\n    background: #FFFFFF;\n    border: 1px solid #C5C9D1;\n    box-shadow: inset 0 1px 3px 0 rgba(0,0,0,0.07);\n    margin-right: ", ";\n    display: flex;\n    cursor: pointer;\n\n    &:hover {\n        border: 1px solid ", ";\n    };\n\n    &[aria-checked = \"true\"] {\n        ", "\n        border: 0px;\n    }\n"])), Theme_1.PixelUnit(1), Theme_1.Color.Blue.B60, Theme_1.Color.Blue.Regular);
CheckBox.displayName = "CheckBox";
var Label = styled_components_1.default.label(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    user-select: none;\n    color: ", ";\n    font-size: ", ";\n"], ["\n    display: flex;\n    user-select: none;\n    color: ", ";\n    font-size: ", ";\n"])), Theme_1.Color.Grey.G70, Theme_1.FontSize);
Label.displayName = "Label";
var Checkbox = /** @class */ (function (_super) {
    __extends(Checkbox, _super);
    function Checkbox(props) {
        var _this = _super.call(this, props) || this;
        _this.toggleCheck = function () {
            var value = !_this.state.Checked;
            _this.setState({ Checked: value }, function () {
                if (_this.props.OnChange) {
                    _this.props.OnChange(value);
                }
            });
        };
        _this.handleClick = function (e) {
            e.stopPropagation();
            _this.toggleCheck();
        };
        _this.handleKeyUp = function (e) {
            if (keyboard.IsSpace(e)) {
                _this.toggleCheck();
            }
        };
        _this.state = ({ Checked: _this.props.Value });
        return _this;
    }
    Checkbox.prototype.UNSAFE_componentWillReceiveProps = function (props) {
        this.setState({ Checked: props.Value });
    };
    Checkbox.prototype.render = function () {
        var checkboxSizeStyle = {
            height: this.props.Size === "Large" ? "20px" : "12px",
            minWidth: this.props.Size === "Large" ? "20px" : "12px",
            width: this.props.Size === "Large" ? "20px" : "12px",
        };
        return (React.createElement(WrapperDiv, { "aria-disabled": this.props.Disabled, onClick: this.handleClick, onKeyUp: this.handleKeyUp },
            React.createElement(CheckBox, { style: checkboxSizeStyle, role: "checkbox", type: "button", disabled: this.props.Disabled, "aria-checked": this.state.Checked, "aria-label": this.props.Label }, this.tickIconDimensions()),
            this.props.HideLabel ? null : React.createElement(Label, null, this.props.Label)));
    };
    Checkbox.prototype.tickIconDimensions = function () {
        if (this.state.Checked) {
            if (this.props.Size === "Large") {
                return (React.createElement(Icon_1.Icon, { Icon: _Core_1.Icons.Tick, Height: "20px", Width: "20px" }));
            }
            else {
                return (React.createElement(Icon_1.Icon, { Icon: _Core_1.Icons.Tick, Height: "12px", Width: "12px" }));
            }
        }
    };
    return Checkbox;
}(React.PureComponent));
exports.Checkbox = Checkbox;
var templateObject_1, templateObject_2, templateObject_3;
